import { Instagram, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Motion";

const PROFILE_PIC =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_game-shot/artifacts/h4eio6kv_IMG_1878.webp";

export const About = () => {
  return (
    <section
      id="about"
      className="relative py-32 md:py-40 max-w-[1600px] mx-auto px-6 md:px-12 scroll-mt-24"
      data-testid="about-section"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-center">
        <Reveal className="md:col-span-4">
          <div className="relative w-48 h-48 md:w-full md:h-auto md:aspect-square max-w-[320px]">
            <div className="absolute -inset-2 border border-[#5cc6ff]/40" />
            <img
              src={PROFILE_PIC}
              alt="TMB Fotografia profile"
              className="relative w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700"
              data-testid="about-profile-pic"
            />
          </div>
        </Reveal>

        <Reveal className="md:col-span-8" delay={0.1}>
          <div className="flex items-center gap-4 mb-6">
            <span className="w-12 h-px bg-[#5cc6ff]" />
            <span className="font-outfit text-xs uppercase tracking-[0.35em] text-white/50">
              About TMB Fotografia
            </span>
          </div>
          <h2 className="font-anton uppercase text-4xl md:text-6xl leading-[0.9] text-white mb-8">
            Behind the <span className="text-[#5cc6ff]">lens</span>
          </h2>
          <p className="font-manrope text-base md:text-lg text-white/60 max-w-2xl leading-relaxed mb-6">
            TMB Fotografia is a freelance sports photographer. Capturing the raw
            moments from the sidelines is his passion. Discover his work and book now.
          </p>
          <a
            href="https://instagram.com/tmbfotografia"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="about-instagram"
            className="inline-flex items-center gap-3 font-outfit uppercase tracking-[0.15em] text-sm text-white/80 hover:text-[#5cc6ff] transition-colors group"
          >
            <Instagram size={18} strokeWidth={1.5} />
            @tmbfotografia
            <ArrowUpRight
              size={16}
              className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
            />
          </a>
        </Reveal>
      </div>
    </section>
  );
};
